<script lang="ts">
  import clsx from "clsx";

  export let checked = false;
  export let changeColor = true;
  export let disabled = false;
  export let label = "";
</script>

<div class="flex">
  <label class="relative inline-flex items-center cursor-pointer">
    <input
      type="checkbox"
      value=""
      class="sr-only peer"
      bind:checked
      on:click
      {disabled}
    />
    <div
      class={clsx(
        "w-9 h-5 peer-focus:outline-none ring-1 ring-white/10 peer-focus:ring-2",
        "peer-focus:ring-primary/30 rounded-full peer bg-white/5 peer-checked:after:translate-x-full",
        "peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px]",
        "after:rounded-full after:h-4 after:w-4",
        "after:transition-all peer-checked:bg-primary/20",
        changeColor
          ? "after:bg-white/60 after:peer-checked:bg-primary"
          : "after:bg-primary",
      )}
    ></div>
    {#if label}
      <span class="ml-3 text-sm text-zinc-400 whitespace-nowrap">
        {label}
      </span>
    {/if}
  </label>
</div>
